import { RESPONSEDATA } from "app/shared/services/services-model.type";
import {
  FETCH_TERM_DEPOSIT_INFO_REQUEST,
  FETCH_TERM_DEPOSIT_INFO_SUCCESS,
  FETCH_TERM_DEPOSIT_INFO_FAILURE,
  FETCH_TERM_DEPOSIT_TERM_REQUEST,
  FETCH_TERM_DEPOSIT_TERM_SUCCESS,
  FETCH_TERM_DEPOSIT_TERM_FAILURE,
  FETCH_TERM_DEPOSIT_MATURITY_REQUEST,
  FETCH_TERM_DEPOSIT_MATURITY_SUCCESS,
  FETCH_TERM_DEPOSIT_MATURITY_FAILURE,
  FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST,
  FETCH_TERM_DEPOSIT_PROMO_CODE_SUCCESS,
  FETCH_TERM_DEPOSIT_PROMO_CODE_FAILURE,
  FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_CREATE_SUCCESS,
  FETCH_TERM_DEPOSIT_OPEN_CREATE_FAILURE,
  FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_CONFIRM_SUCCESS,
  FETCH_TERM_DEPOSIT_OPEN_CONFIRM_FAILURE,
  FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_SUCCESS,
  FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_FAILURE,
  FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST,
  FETCH_TERM_DEPOSIT_PROMOTIONS_SUCCESS,
  FETCH_TERM_DEPOSIT_PROMOTIONS_FAILURE,
  SET_TERM_OPEN_STORE,
  SET_TERM_OPEN_RESET,
} from "./actions.type";
import {
  FetchTermDepositInfoRequest,
  FetchTermDepositInfoSuccess,
  FetchTermDepositInfoFailure,
  FetchTermDepositTermRequest,
  FetchTermDepositTermSuccess,
  FetchTermDepositTermFailure,
  FetchTermDepositMaturityRequest,
  FetchTermDepositMaturitySuccess,
  FetchTermDepositMaturityFailure,
  FetchTermDepositPromoCodeRequest,
  FetchTermDepositPromoCodeSuccess,
  FetchTermDepositPromoCodeFailure,
  FetchTermDepositOpenCreateRequest,
  FetchTermDepositOpenCreateSuccess,
  FetchTermDepositOpenCreateFailure,
  FetchTermDepositOpenConfirmRequest,
  FetchTermDepositOpenConfirmSuccess,
  FetchTermDepositOpenConfirmFailure,
  FetchTermDepositOpenAuthorizationRequest,
  FetchTermDepositOpenAuthorizationSuccess,
  FetchTermDepositOpenAuthorizationFailure,
  FetchTermDepositPromotionsRequest,
  FetchTermDepositPromotionsSuccess,
  FetchTermDepositPromotionsFailure,
  DataTermDepositCreate,
  SetTermOpenStore,
  SetTermOpenReset,
  TermDepositOpenState,
} from "./types";

export const fetchTermDepositInfoRequest = (payload?: string): FetchTermDepositInfoRequest => ({
  type: FETCH_TERM_DEPOSIT_INFO_REQUEST,
  payload,
});

export const fetchTermDepositInfoSuccess = (payload?: RESPONSEDATA): FetchTermDepositInfoSuccess => ({
  type: FETCH_TERM_DEPOSIT_INFO_SUCCESS,
  payload,
});

export const fetchTermDepositInfoFailure = (payload?: string): FetchTermDepositInfoFailure => ({
  type: FETCH_TERM_DEPOSIT_INFO_FAILURE,
  payload,
});

export const fetchTermDepositTermRequest = (payload?: string): FetchTermDepositTermRequest => ({
  type: FETCH_TERM_DEPOSIT_TERM_REQUEST,
  payload,
});

export const fetchTermDepositTermSuccess = (payload?: RESPONSEDATA): FetchTermDepositTermSuccess => ({
  type: FETCH_TERM_DEPOSIT_TERM_SUCCESS,
  payload,
});

export const fetchTermDepositTermFailure = (payload?: string): FetchTermDepositTermFailure => ({
  type: FETCH_TERM_DEPOSIT_TERM_FAILURE,
  payload,
});

export const fetchTermDepositMaturityRequest = (payload?: string): FetchTermDepositMaturityRequest => ({
  type: FETCH_TERM_DEPOSIT_MATURITY_REQUEST,
  payload,
});

export const fetchTermDepositMaturitySuccess = (payload?: RESPONSEDATA): FetchTermDepositMaturitySuccess => ({
  type: FETCH_TERM_DEPOSIT_MATURITY_SUCCESS,
  payload,
});

export const fetchTermDepositMaturityFailure = (payload?: string): FetchTermDepositMaturityFailure => ({
  type: FETCH_TERM_DEPOSIT_MATURITY_FAILURE,
  payload,
});

export const fetchTermDepositPromoCodeRequest = (payload?: DataTermDepositCreate): FetchTermDepositPromoCodeRequest => ({
  type: FETCH_TERM_DEPOSIT_PROMO_CODE_REQUEST,
  payload,
});

export const fetchTermDepositPromoCodeSuccess = (payload?: RESPONSEDATA): FetchTermDepositPromoCodeSuccess => ({
  type: FETCH_TERM_DEPOSIT_PROMO_CODE_SUCCESS,
  payload,
});

export const fetchTermDepositPromoCodeFailure = (payload?: string): FetchTermDepositPromoCodeFailure => ({
  type: FETCH_TERM_DEPOSIT_PROMO_CODE_FAILURE,
  payload,
});

export const fetchTermDepositOpenCreateRequest = (payload?: DataTermDepositCreate): FetchTermDepositOpenCreateRequest => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CREATE_REQUEST,
  payload,
});

export const fetchTermDepositOpenCreateSuccess = (payload?: RESPONSEDATA): FetchTermDepositOpenCreateSuccess => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CREATE_SUCCESS,
  payload,
});

export const fetchTermDepositOpenCreateFailure = (payload?: string): FetchTermDepositOpenCreateFailure => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CREATE_FAILURE,
  payload,
});

export const fetchTermDepositOpenConfirmRequest = (payload?: RESPONSEDATA): FetchTermDepositOpenConfirmRequest => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CONFIRM_REQUEST,
  payload,
});

export const fetchTermDepositOpenConfirmSuccess = (payload?: RESPONSEDATA): FetchTermDepositOpenConfirmSuccess => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CONFIRM_SUCCESS,
  payload,
});

export const fetchTermDepositOpenConfirmFailure = (payload?: string): FetchTermDepositOpenConfirmFailure => ({
  type: FETCH_TERM_DEPOSIT_OPEN_CONFIRM_FAILURE,
  payload,
});

export const fetchTermDepositOpenAuthorizationRequest = (
  payload?: RESPONSEDATA,
  code?: string,
): FetchTermDepositOpenAuthorizationRequest => ({
  type: FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_REQUEST,
  payload,
  code,
});

export const fetchTermDepositOpenAuthorizationSuccess = (payload?: RESPONSEDATA): FetchTermDepositOpenAuthorizationSuccess => ({
  type: FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_SUCCESS,
  payload,
});

export const fetchTermDepositOpenAuthorizationFailure = (payload?: boolean, msg?: string): FetchTermDepositOpenAuthorizationFailure => ({
  type: FETCH_TERM_DEPOSIT_OPEN_AUTHORIZATION_KEY_FAILURE,
  payload,
  msg,
});

export const fetchTermDepositPromotionsRequest = (payload?: RESPONSEDATA): FetchTermDepositPromotionsRequest => ({
  type: FETCH_TERM_DEPOSIT_PROMOTIONS_REQUEST,
  payload,
});

export const fetchTermDepositPromotionsSuccess = (payload?: RESPONSEDATA): FetchTermDepositPromotionsSuccess => ({
  type: FETCH_TERM_DEPOSIT_PROMOTIONS_SUCCESS,
  payload,
});

export const fetchTermDepositPromotionsFailure = (payload?: string): FetchTermDepositPromotionsFailure => ({
  type: FETCH_TERM_DEPOSIT_PROMOTIONS_FAILURE,
  payload,
});

export const setTermOpenStore = (payload: TermDepositOpenState): SetTermOpenStore => ({
  type: SET_TERM_OPEN_STORE,
  payload,
});

export const setTermOpenReset = (): SetTermOpenReset => ({
  type: SET_TERM_OPEN_RESET,
});
